import React from "react";

import styles from "../style/ChatBotWindow.module.css";

/**
 * Loading dots animation component for the chat interface
 * Shows animated ellipsis dots with varying opacity and scale
 */
const LoadingDots: React.FC = () => {
  return (
    <div className={styles.loadingDots}>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
    </div>
  );
};

export default LoadingDots;
